import { render, staticRenderFns } from "./searchbyfda.vue?vue&type=template&id=25421556&"
import script from "./searchbyfda.vue?vue&type=script&lang=js&"
export * from "./searchbyfda.vue?vue&type=script&lang=js&"
import style0 from "./searchbyfda.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports